module.exports = __webpack_public_path__ + "img/cg_race20_20.0bd78ce.jpg";